import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=3bd5596c"
import script from "./ListItem.vue?vue&type=script&lang=ts"
export * from "./ListItem.vue?vue&type=script&lang=ts"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=3bd5596c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports